<template>
  <div class="multi-net-info">
    <!-- 基本信息 -->
    <div class="info-section">
      <div class="section-title">基本信息</div>
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">组网号:</span>
          <span class="info-value">{{ multiNetInfo.groupNo }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">多网卡状态:</span>
          <span class="info-value" :class="multiNetStatusClass">{{ multiNetStatusText }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">组网时间:</span>
          <span class="info-value">{{ multiNetInfo.openTime ? parseTime(multiNetInfo.openTime,'{y}-{m}-{d}') : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">ICCID-移动:</span>
          <span class="info-value">{{ multiNetInfo.ydIccid ? multiNetInfo.ydIccid : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">ICCID-电信:</span>
          <span class="info-value">{{ multiNetInfo.dxIccid ? multiNetInfo.dxIccid : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">IMEI:</span>
          <span class="info-value">{{ multiNetInfo.imei ? multiNetInfo.imei : '--' }}</span>
        </div>
        
        <div class="info-item">
          <span class="info-label">订单编号:</span>
          <span class="info-value">{{ multiNetInfo.orderNum ? multiNetInfo.orderNum : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">正式套餐:</span>
          <span class="info-value">{{ multiNetInfo.productName ? multiNetInfo.productName : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">套餐周期:</span>
          <span class="info-value">{{ multiNetInfo.productPeriod ? multiNetInfo.productPeriod : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">套餐总量:</span>
          <span class="info-value">{{ multiNetInfo.productMonthFlow =='-1'?'畅享流量' : multiNetInfo.productMonthFlow + 'MB' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">套餐已用量:</span>
          <span class="info-value">{{ multiNetInfo.productUseFlow =='-1'?'畅享流量' : multiNetInfo.productUseFlow + 'MB' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">套餐剩余量:</span>
          <span class="info-value">{{ multiNetInfo.productResidueFlow =='-1'?'畅享流量' : multiNetInfo.productResidueFlow + 'MB' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">当月流量:</span>
          <span class="info-value">{{ multiNetInfo.monthFlow }}MB</span>
        </div>
        <div class="info-item">
          <span class="info-label">套餐激活时间:</span>
          <span class="info-value">{{ multiNetInfo.productActiveTime ? multiNetInfo.productActiveTime : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">正式套餐到期时间:</span>
          <span class="info-value">{{ multiNetInfo.productExpireTime ? multiNetInfo.productExpireTime : '--' }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">卡片激活时间:</span>
          <span class="info-value">{{ multiNetInfo.cardActiveTime ? multiNetInfo.cardActiveTime : '--' }}</span>
        </div>
        
        <div class="info-item">
          <span class="info-label">流量同步时间:</span>
          <span class="info-value">{{ multiNetInfo.syncTime ? multiNetInfo.syncTime : '--' }}</span>
        </div>
        
        <div class="info-item">
          <span class="info-label">代理商:</span>
          <span class="info-value">{{ multiNetInfo.agentName ? multiNetInfo.agentName : '--' }}</span>
        </div>
        <div class="info-item" v-if="adminShow">
          <span class="info-label">层级展示:</span>
          <span class="info-value">{{ multiNetInfo.agentNamePath ? multiNetInfo.agentNamePath : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">备注:</span>
          <span class="info-value">{{ multiNetInfo.remark ? multiNetInfo.remark : '' }}</span>
        </div>
        <div class="info-item" v-if="adminShow">
          <span class="info-label">开启同步:
            <el-tooltip content="手动操作停用会关闭组网的同步状态，启用会自动开启同步状态" placement="top">
              <i class="el-icon-question sync-tip-icon"></i>
            </el-tooltip>
          </span>
          <span class="info-value">{{ multiNetInfo.sync == '1' ? '已开启' : '已关闭' }}</span>
        </div>
      </div>
    </div>

    <!-- 组网成员 -->
    <div class="info-section">
      <div class="section-title">组网成员</div>
      <div class="member-cards">
        <div class="member-card">
          <div class="member-card-header">电信</div>
          <div class="member-card-body">
            <div class="member-info">
              <span class="member-label">ICCID：</span>
              <span
                class="member-value"
                :class="{ 'card-link': multiNetInfo.dxCard.iccid }"
                @click="goCardDetail(multiNetInfo.dxCard.iccid)"
              >{{ multiNetInfo.dxCard.iccid || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">MSISDN：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.msisdn || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">运营状态：</span>
              <span class="member-value" :class="getStatusClass(multiNetInfo.dxCard.cardStatus)">{{ multiNetInfo.dxCard.cardStatus || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">状态：</span>
              <span class="member-value" :class="getStatusClass(multiNetInfo.dxCard.showStatus)">{{ multiNetInfo.dxCard.showStatus || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">当月流量：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.showMonthFlow? multiNetInfo.dxCard.showMonthFlow: '0' }}MB</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">卡源：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.cardSourceName || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">GPRS：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.gprsStatus == null ? '--' : (multiNetInfo.dxCard.gprsStatus === '1' ? '开启' : '关闭') }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">分配时间：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.lastAdminTransferTime || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">销户时间：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.delTime || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">卡定向类型：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.orientation || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">是否锁卡：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.cardLock == null ? '--' : (multiNetInfo.dxCard.cardLock === 'lock' ? '锁卡' : '未锁卡') }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">开启同步：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.sync == null  ? '--' : (multiNetInfo.dxCard.sync === '1' ? '开启' : '关闭')  }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">卡品类型：</span>
              <span class="member-value">{{ multiNetInfo.dxCard.cardTypeSortName || '--' }}</span>
            </div>
          </div>
        </div>
        <div class="member-card">
          <div class="member-card-header">移动</div>
          <div class="member-card-body">
            <div class="member-info">
              <span class="member-label">ICCID：</span>
              <span
                class="member-value"
                :class="{ 'card-link': multiNetInfo.ydCard.iccid }"
                @click="goCardDetail(multiNetInfo.ydCard.iccid)"
              >{{ multiNetInfo.ydCard.iccid || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">MSISDN：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.msisdn || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">运营状态：</span>
              <span class="member-value" :class="getStatusClass(multiNetInfo.ydCard.cardStatus)">{{ multiNetInfo.ydCard.cardStatus || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">状态：</span>
              <span class="member-value" :class="getStatusClass(multiNetInfo.ydCard.showStatus)">{{ multiNetInfo.ydCard.showStatus || '--' }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">当月流量：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.showMonthFlow? multiNetInfo.ydCard.showMonthFlow: '0' }}MB</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">卡源：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.cardSourceName || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">GPRS：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.gprsStatus == null ? '--' : (multiNetInfo.ydCard.gprsStatus === '1' ? '开启' : '关闭') }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">分配时间：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.lastAdminTransferTime || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">销户时间：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.delTime || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">卡定向类型：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.orientation || '--' }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">是否锁卡：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.cardLock == null ? '--' : (multiNetInfo.ydCard.cardLock === 'lock' ? '锁卡' : '未锁卡') }}</span>
            </div>
            <div class="member-info" v-if="adminShow">
              <span class="member-label">开启同步：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.sync == null ? '--' : (multiNetInfo.ydCard.sync === '1' ? '开启' : '关闭') }}</span>
            </div>
            <div class="member-info">
              <span class="member-label">卡品类型：</span>
              <span class="member-value">{{ multiNetInfo.ydCard.cardTypeSortName || '--' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <el-button v-if="checkPermi(['card:multiNet:batchUnpack'])" type="warning" @click="handleDisband">拆网</el-button>
        <el-button type="success" @click="handleRefreshCard">立即更新</el-button>
        <el-button v-hasPermi="['card:multiNet:stop']" v-if="multiNetInfo.status == '4'"  type="warning" @click="handleStopCard">停用</el-button>
        <el-button v-hasPermi="['card:multiNet:open']" v-if="multiNetInfo.status == '5'"  type="primary" @click="handleOpenCard">启用</el-button>
        <el-button type="info" @click="handleDiagnosisCard">一键诊断</el-button>
      </div>
    </div>

    <!-- Tab 区域 -->
    <div class="info-section">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="套餐详情" name="package">
          <div class="filter-bar">
            <el-select v-model="filterPackageStatus" placeholder="套餐状态" clearable class="filter-select" @change="getPackageList">
              <el-option
                v-for="item in packageStatusOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <el-table :data="packageList" border stripe v-loading="loading" class="data-table">
            <el-table-column prop="productName" label="套餐名" align="center" min-width="120"></el-table-column>
            <el-table-column prop="status" label="套餐状态" align="center" width="100">
              <template slot-scope="scope">
                <el-tag :type="getPackageStatusType(scope.row.status)">{{ getPackageStatusName(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="useFlow" label="已用流量(M)" align="center" width="110"></el-table-column>
            <el-table-column prop="monthFlow" label="总流量(M)" align="center" width="110">
              <template slot-scope="scope">
                {{ scope.row.monthFlow =='-1'?'畅享流量' : scope.row.monthFlow }}
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="生效时间" align="center" width="160"></el-table-column>
            <el-table-column prop="endTime" label="到期时间" align="center" width="160"></el-table-column>
            <el-table-column prop="createTime" label="订购时间" align="center" width="160"></el-table-column>
            <el-table-column prop="type" label="套餐类型" align="center" width="100">
              <template slot-scope="scope">
                {{ getPackageTypeName(scope.row.type) }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="cancelTime" label="退订时间" align="center" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.cancelTime || '--' }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="orderNum" label="订单号" align="center" width="210"></el-table-column>
            <el-table-column label="操作" align="center" width="120" fixed="right" v-if="adminShow">
              
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="订单列表" name="orderList">
          <el-table :data="orderList" border stripe v-loading="orderLoading" class="data-table">
            <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
            <el-table-column prop="orderNum" label="订单号" align="center" min-width="140"></el-table-column>
            <el-table-column prop="productName" label="资费名" align="center" min-width="120"></el-table-column>
            <el-table-column prop="productFlow" label="资费流量(M)" align="center" width="110">
              <template slot-scope="scope">
                {{ Number(scope.row.productFlow) === -1 ? '畅享流量' : scope.row.productFlow }}
              </template>
            </el-table-column>
            <el-table-column prop="accountMoney" label="价格" align="center" width="100"></el-table-column>
            <el-table-column prop="currency" label="币种" align="center" width="80"></el-table-column>
            <el-table-column prop="orderStatus" label="状态" align="center" width="100">
              <template slot-scope="scope">
                <el-tag :type="getOrderStatusType(scope.row.orderStatus)">{{ getOrderStatusName(scope.row.orderStatus) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="payType" label="支付方式" align="center" width="120" v-if="adminShow">
              <template slot-scope="scope">
                {{ getPayTypeName(scope.row.payType) }}
              </template>
            </el-table-column>
            <el-table-column prop="payType" label="支付渠道" align="center" width="120" v-if="firstAgent">
              <template slot-scope="scope">
                {{ transferScene(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="payTime" label="支付时间" align="center" width="160"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center" min-width="120" v-if="adminShow"></el-table-column>
            <el-table-column label="操作" align="center" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-if="showRefund(scope.row)"
                  type="text"
                  size="small"
                  class="refund-btn"
                  @click="handleRefund(scope.row)"
                >退款</el-button>
                <span v-else class="no-refund-text">--</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="操作记录" name="operationRecord">
          <div class="filter-bar">
            <el-select v-model="filterRecordIccid" placeholder="选择ICCID" clearable class="filter-select" @change="handleRecordFilterChange">
              <el-option
                v-for="item in multiCardList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-table :data="operationRecordList" border stripe v-loading="recordLoading" class="data-table">
            <el-table-column prop="iccid" label="ICCID" align="center" min-width="180"></el-table-column>
            <el-table-column prop="operation" label="状态" align="center" width="160"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center" width="160"></el-table-column>
            <el-table-column prop="reqReason" label="备注" align="center" min-width="240">
              <template slot-scope="scope">
                {{ scope.row.reqReason && scope.row.reqReason !== 'null' ? scope.row.reqReason : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人" align="center" width="120"></el-table-column>
          </el-table>
          <pagination
            v-show="recordTotal > 0"
            :total="recordTotal"
            :page.sync="recordPage"
            :limit.sync="recordPageSize"
            @pagination="getOperationRecordList"
          />
        </el-tab-pane>

        <el-tab-pane label="月流量统计" name="monthFlow" v-if="checkPermi(['card:multiNet:monthFlow'])">
          <month-chart v-if="activeTab === 'monthFlow'" :groupNo="groupNo" :type="2"></month-chart>
        </el-tab-pane>

        <el-tab-pane label="日流量统计" name="dayFlow" v-if="checkPermi(['card:multiNet:dayFlow'])">
          <month-chart v-if="activeTab === 'dayFlow'" :groupNo="groupNo" :type="1"></month-chart>
        </el-tab-pane>
        <el-tab-pane label="诊断结果" name="diagnosis">
          <div class="diagnosis-empty" v-if="!multiNetInfo.dxCard.iccid && !multiNetInfo.ydCard.iccid">
            <i class="el-icon-warning"></i>
            <span>未组网 诊断失败</span>
          </div>
          <div class="diagnosis-list" v-else-if="!diagnosing">
            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisCard.type">
                <i :class="diagnosisCard.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisCard.title }}</span>
                  <el-tag :type="diagnosisCard.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisCard.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisCard.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail" v-if="diagnosisCard.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisCard.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisProduct.type">
                <i :class="diagnosisProduct.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisProduct.title }}</span>
                  <el-tag :type="diagnosisProduct.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisProduct.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisProduct.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail" v-if="diagnosisProduct.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisProduct.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisFlow.type">
                <i :class="diagnosisFlow.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisFlow.title }}</span>
                  <el-tag :type="diagnosisFlow.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisFlow.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisFlow.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail" v-if="diagnosisFlow.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisFlow.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisBind.type">
                <i :class="diagnosisBind.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisBind.title }}</span>
                  <el-tag :type="diagnosisBind.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisBind.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisBind.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail diagnosis-detail--lock" v-if="diagnosisBind.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisBind.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                    <span class="detail-lock" :class="row.locked ? 'is-locked' : 'is-unlocked'">{{ row.lock }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisRealname.type">
                <i :class="diagnosisRealname.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisRealname.title }}</span>
                  <el-tag :type="diagnosisRealname.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisRealname.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisRealname.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail diagnosis-detail--remark" v-if="diagnosisRealname.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisRealname.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                    <span class="detail-remark">{{ row.remark }}</span>
                  </div>
                </div>
              </div>
            </div>


            <div class="diagnosis-item">
              <div class="diagnosis-icon" :class="'icon-' + diagnosisRegion.type">
                <i :class="diagnosisRegion.icon"></i>
              </div>
              <div class="diagnosis-content">
                <div class="diagnosis-title">
                  <span class="title-text">{{ diagnosisRegion.title }}</span>
                  <el-tag :type="diagnosisRegion.status === '正常' ? 'success' : 'danger'" size="mini">
                    <i class="el-icon-success" v-if="diagnosisRegion.status === '正常'"></i>
                    <i class="el-icon-warning" v-else></i>
                    {{ diagnosisRegion.status }}
                  </el-tag>
                </div>
                <div class="diagnosis-detail diagnosis-detail--remark" v-if="diagnosisRegion.details">
                  <div class="detail-row" v-for="(row, rIdx) in diagnosisRegion.details" :key="rIdx">
                    <span class="detail-label">{{ row.label }}</span>
                    <span class="detail-value">{{ row.value }}</span>
                    <span class="detail-remark">{{ row.remark }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="diagnosis-loading" v-else>
            <i class="el-icon-loading"></i>
            <span>正在诊断，请稍候...</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 退款弹窗 -->
    <el-dialog title="订单退款" :visible.sync="refundDialogVisible" width="560px" :close-on-click-modal="false">
      <div v-loading="refundDetailLoading">
        <div class="refund-section-title">订单信息</div>
        <div class="refund-info-grid">
          <div class="refund-info-item">
            <span class="label">订单号：</span>
            <span class="value">{{ refundOrder.orderNum || '--' }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">资费名：</span>
            <span class="value">{{ refundOrder.productName || '--' }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">资费流量：</span>
            <span class="value">{{ Number(refundOrder.productFlow) === -1 ? '畅享流量' : (refundOrder.productFlow ? refundOrder.productFlow + 'M' : '--') }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">支付方式：</span>
            <span class="value">{{ getPayTypeName(refundOrder.payType) }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">支付时间：</span>
            <span class="value">{{ refundOrder.payTime || '--' }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">订单金额：</span>
            <span class="value refund-money">{{ refundOrder.accountMoney }} {{ refundOrder.currency }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">已申请退款：</span>
            <span class="value">{{ refundDetailData.alreadyRefundMoney != null ? refundDetailData.alreadyRefundMoney + ' 元' : '--' }}</span>
          </div>
          <div class="refund-info-item">
            <span class="label">最多可退：</span>
            <span class="value refund-money">{{ refundMaxAmount }} 元</span>
          </div>
        </div>

        <div class="refund-section-title">退款信息</div>
        <el-form label-width="90px" size="small">
          <el-form-item label="退款金额" required>
            <el-input-number
              v-model="refundForm.refundAmount"
              :precision="2"
              :min="0.00"
              :max="refundMaxAmount"
              controls-position="right"
              style="width: 200px"
            ></el-input-number>
            <span class="refund-tip">(最多可退 {{ refundMaxAmount }} 元)</span>
          </el-form-item>
          <el-form-item label="退款说明">
            <el-input
              v-model="refundForm.remark"
              placeholder="请输入退款说明"
              maxlength="50"
              style="width: 260px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="refundSubmitting" @click="confirmRefund">确定退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cardMultiNetInfo, cardMultiNetProductList, multiMultiNetOrderList, multiMultiNetOperationRecord, refreshMultiNetCard, stopMultiNetCard, openMultiNetCard ,unpackCardMultiCard} from '@/api/multiNet'
import { refundDetail, refundRefundOrder, checkOrderAutoRenewal } from '@/api/api'
import MonthChart from './MonthChart.vue'

export default {
  // name: 'MultiNetInfo',
  components: {
    MonthChart
  },
  data() {
    return {
      loading: false,
      orderLoading: false,
      recordLoading: false,
      diagnosing: false,
      activeTab: 'package',
      filterPackage: '',
      filterPackageStatus: '',
      filterRecordIccid: '',
      page: 1,
      pageSize: 10,
      total: 2,
      recordPage: 1,
      recordPageSize: 10,
      recordTotal: 0,
      groupNo: this.$route.query && this.$route.query.groupNo || '',
      multiNetInfo: {
        ydCard:{},
        dxCard:{}
      },
      multiCardList:[],
      packageStatusOptions: [
        { id: '1', name: '未使用', type: 'info' },
        { id: '2', name: '正使用', type: 'success' },
        { id: '3', name: '已使用', type: 'warning' },
        { id: '4', name: '已过期', type: 'danger' },
        { id: '5', name: '已转移', type: '' },
        { id: '6', name: '已作废', type: 'danger' },
        { id: '7', name: '已清除', type: 'info' }
      ],
      packageTypeOptions: [
        { id: '1', name: '累计套餐' },
        { id: '2', name: '月套餐' },
        { id: '3', name: '加油包' },
        { id: '4', name: '停机保号套餐' },
        { id: '5', name: '补卡套餐' },
        { id: '6', name: '加速包套餐' },
        { id: '7', name: '测试套餐' },
        { id: '8', name: '赠送套餐' },
        { id: '9', name: '发票套餐' },
        { id: '10', name: '流量池加油包' },
        { id: '11', name: '卡试用套餐' }
      ],
      packageList: [],
      orderList: [],
      operationRecordList: [],
      orderStatusOptions: [
        { id: '1', name: '未支付', type: 'info' },
        { id: '2', name: '已支付', type: 'success' },
        { id: '3', name: '已到账', type: 'success' },
        { id: '4', name: '已退款', type: 'warning' },
        { id: '7', name: '退款中', type: 'warning' },
        { id: '8', name: '退款失败', type: 'danger' }
      ],
      payTypeOptions: [
        { id: '1', name: 'H5支付' },
        { id: '2', name: '微信支付' },
        { id: '3', name: '余额支付' },
        { id: '4', name: '系统支付' },
        { id: '5', name: '支付宝' },
        { id: '6', name: '贝宝支付' },
        { id: '7', name: '佣金支付' },
        { id: '8', name: '小程序支付' },
        { id: '9', name: '云闪付支付' },
        { id: '10', name: 'Stripe支付' }
      ],
      diagnosisCard:{
          type: 'card',
          icon: 'el-icon-postcard',
          title: '卡片状态',
          status: '正常',
          details: []
      },
      diagnosisProduct:{
          type: 'package',
          icon: 'el-icon-present',
          title: '套餐状态',
          status: '正常',
          details: [
            { label: '卡片套餐：', value: '' },
            { label: '套餐到期时间：', value: '' }
          ]
      },
      diagnosisFlow:{
          type: 'flow',
          icon: 'el-icon-data-line',
          title: '流量状态',
          status: '正常',
          details: [
            { label: '可使用流量(MB)：', value: '0' },
            { label: '已使用流量(MB)：', value: '0' }
          ]
      },
      diagnosisBind:{
          type: 'bind',
          icon: 'el-icon-link',
          title: '机卡绑定状态',
          status: '正常',
          details: []
      },
      diagnosisRealname:{
          type: 'realname',
          icon: 'el-icon-user',
          title: '实名状态',
          status: '正常',
          details: []
      },
      diagnosisRegion:{
          type: 'region',
          icon: 'el-icon-location-information',
          title: '是否触发区域限制',
          status: '正常',
          details: []
      },
      // 退款弹窗
      refundDialogVisible: false,
      refundDetailLoading: false,
      refundSubmitting: false,
      refundOrder: {},
      refundDetailData: {},
      refundMaxAmount: 0,
      refundForm: {
        mode: '1',
        refundAmount: undefined,
        remark: ''
      },
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    },
    firstAgent(){
      return this.$store.getters.user.userType !='1' && this.$store.getters.user.level =='1';
    },
    // 多网卡状态文案：与 multiNet/index.vue 列表 el-tag 文案保持一致
    multiNetStatusText() {
      const s = this.multiNetInfo.status
      if (s === '4' || s === 4) return '可用'
      if (s === '5' || s === 5) return '停用'
      return '作废'
    },
    // 多网卡状态样式类：可用-success(绿) / 停用-danger(红) / 作废-info(灰)
    // 与 multiNet/index.vue 表格 el-tag 配色保持一致
    multiNetStatusClass() {
      const s = this.multiNetInfo.status
      if (s === '4' || s === 4) return 'status-success'
      if (s === '5' || s === 5) return 'status-danger'
      return 'status-info'
    }
  },
  created() {
    // 支持从外部携带 tab 参数跳转，直接定位到对应 tab
    const tab = this.$route.query && this.$route.query.tab
    if (tab) {
      this.activeTab = tab
    }
    this.initData()
    this.getPackageList()
  },
  methods: {
    // 跳转卡详情
    goCardDetail(iccid) {
      if (!iccid) return
      this.$router.push({ path: '/card/detail', query: { iccid } })
    },
    handleTabClick(tab) {
      if (tab.name === 'package') {
        this.getPackageList()
      } else if (tab.name === 'orderList') {
        this.getOrderList()
      } else if (tab.name === 'operationRecord') {
        this.getOperationRecordList()
      }

    },
    // 根据状态返回样式类名
    getStatusClass(status) {
      if (!status) return ''
      const s = status.replace(/\s/g, '')
      if (s.includes('预销户') || s.includes('已销户') || s.includes('已停机')) {
        return 'status-danger'
      }
      if (s.includes('已激活')) {
        return 'status-active'
      }
      return 'status-primary'
    },
    initData() {
      const  groupNo = this.$route.query && this.$route.query.groupNo
      if (groupNo) {
        this.loading = true
        cardMultiNetInfo({
          groupNo: groupNo
        }).then(res => {
          this.loading = false
          this.multiNetInfo = res.data.data;
          if(res.data.data.dxIccid){
            this.multiCardList.push({"label":"电信："+res.data.data.dxIccid,"value":res.data.data.dxIccid})
          }
          if(res.data.data.ydIccid){
            this.multiCardList.push({"label":"移动："+res.data.data.ydIccid,"value":res.data.data.ydIccid}) 
          } 
          this.initDiagnosisCard(res.data.data)
        })
      }
    },
    initDiagnosisCard(multiNetInfo){
      
      // 重置诊断数据，避免重复诊断时 details 累加
      this.diagnosisCard.details = []
      this.diagnosisProduct.details = [
        { label: '卡片套餐：', value: '' },
        { label: '套餐到期时间：', value: '' }
      ]
      this.diagnosisFlow.details = [
        { label: '可使用流量(MB)：', value: '0' },
        { label: '已使用流量(MB)：', value: '0' }
      ]
      this.diagnosisBind.details = []
      this.diagnosisRealname.details = []
      this.diagnosisRegion.details = []
      this.diagnosisCard.status = multiNetInfo.status == '4' ? '正常' : '停用'
      // 套餐状态
      this.diagnosisProduct.status = multiNetInfo.flowStatus == '0' ? '不正常' : '正常'
      this.diagnosisProduct.details[0].value = multiNetInfo.diagnosisProductName
      this.diagnosisProduct.details[1].value = multiNetInfo.diagnosisProductExpire
      // 流量状态
      this.diagnosisFlow.status = multiNetInfo.flowStatus == '0' ? '已使用' : '正常'
      this.diagnosisFlow.details[0].value = multiNetInfo.productResidueFlow
      this.diagnosisFlow.details[1].value = multiNetInfo.productUseFlow

      // 绑定状态
      let dxCard = multiNetInfo.dxCard;
      let ydCard = multiNetInfo.ydCard;
      let dxLock = false, ydLock = false;
      if(dxCard.iccid){
        dxLock = dxCard.cardLock == 'lock'
        let dxBind = {label : '电信：', value : dxCard.iccid, lock: dxLock ? '已锁定' : '未锁定', locked: dxLock}
        this.diagnosisBind.details.push(dxBind)
      }
      if(ydCard.iccid){
        ydLock = ydCard.cardLock == 'lock'
        let ydBind = {label : '移动：', value : ydCard.iccid, lock: ydLock ? '已锁定' : '未锁定', locked: ydLock}
        this.diagnosisBind.details.push(ydBind)
      }
      // 两张卡都锁定时，总状态为已锁定
      if(dxLock && ydLock){
        this.diagnosisBind.status = '已锁定'
      }

      // 实名状态
      if(dxCard.iccid){
        let dxBind = {label : '电信：', value : dxCard.iccid, remark: '该卡不需要实名认证!'}
        this.diagnosisRealname.details.push(dxBind)
      }
      if(ydCard.iccid){
        let ydBind = {label : '移动：', value : ydCard.iccid, remark: '该卡不需要实名认证!'}
        this.diagnosisRealname.details.push(ydBind)
      }
      // 区域限制
      if(dxCard.iccid){
        let dxBind = {label : '电信：', value : dxCard.iccid, remark: '未触发'}
        this.diagnosisRegion.details.push(dxBind)
      }
      if(ydCard.iccid){
        let ydBind = {label : '移动：', value : ydCard.iccid, remark: '未触发'}
        this.diagnosisRegion.details.push(ydBind)
      }
      // 诊断数据填充完成，结束诊断中状态
      this.diagnosing = false
    },
    getPackageList() {
      this.loading = true
      const groupNo = this.$route.query && this.$route.query.groupNo
      cardMultiNetProductList({
        groupNo: groupNo,
        status: this.filterPackageStatus
      }).then(res => {
        this.loading = false
        this.packageList = res.data.data || []
      })
    },
    getOrderList() {
      this.orderLoading = true
      const groupNo = this.$route.query && this.$route.query.groupNo
      multiMultiNetOrderList({
        groupNo: groupNo
      }).then(res => {
        this.orderLoading = false
        this.orderList = res.data.data || []
      })
    },
    getOperationRecordList() {
      this.recordLoading = true
      const groupNo = this.$route.query && this.$route.query.groupNo
      const params = {
        model:{
          groupNo: groupNo,
        },
        page: this.recordPage,
        pageSize: this.recordPageSize
      }
      if (this.filterRecordIccid) {
        params.model.iccid = this.filterRecordIccid
      }
      multiMultiNetOperationRecord(params).then(res => {
        this.recordLoading = false
        this.operationRecordList = res.data.data.records || []
        this.recordTotal = res.data.data.total || 0
      })
    },
    handleRecordFilterChange() {
      this.recordPage = 1
      this.getOperationRecordList()
    },
    handleRefreshCard() {
      const groupNo = this.$route.query && this.$route.query.groupNo
      refreshMultiNetCard({
        groupNo: groupNo
      }).then(res => {
        if(res.data.code == 200){
          this.$message.success('刷新成功')
          this.initData()
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    //启用
    handleOpenCard(){
      this.$confirm('确认启用该组网?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        openMultiNetCard({
          groupNo: this.groupNo
        }).then(res => {
          if(res.data.code == 200){
            this.$message.success('启用组网处理中')
            this.initData()
          }else{
            this.$message.error(res.data.message)
          }
        })
      }).catch(() => {})
    },
    //停用
    handleStopCard() {
      this.$confirm('确认停用该组网?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stopMultiNetCard({
          groupNo: this.groupNo
        }).then(res => {
          if(res.data.code == 200){
            this.$message.success('停用组网处理中')
            this.initData()
          }else{
            this.$message.error(res.data.message)
          }
        })
      }).catch(() => {})
    },
    //一键诊断
    handleDiagnosisCard(){
      // 跳转到诊断结果tab，接口返回前显示诊断中
      this.diagnosing = true
      this.activeTab = 'diagnosis'
      refreshMultiNetCard({
        groupNo: this.groupNo
      }).then(res => {
        if(res.data.code == 200){
          this.initData()
        }else{
          this.$message.error(res.data.message)
          this.diagnosing = false
        }
      }).catch(() => {
        this.diagnosing = false
      })
    },
    handleDisband() {
      this.$confirm('确认拆开该组网?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          name: 'multiNetUnpack',
          params:{iccids:this.groupNo}
        })
      }).catch(() => {})
    },
    handleTransfer() {
      this.$message.info('划拨整组功能开发中')
    },
    getPackageStatusType(status) {
      const opt = this.packageStatusOptions.find(o => o.id === String(status))
      return opt ? (opt.type || 'info') : 'info'
    },
    getPackageStatusName(status) {
      const opt = this.packageStatusOptions.find(o => o.id === String(status))
      return opt ? opt.name : status
    },
    getPackageTypeName(type) {
      const opt = this.packageTypeOptions.find(o => o.id === String(type))
      return opt ? opt.name : (type || '--')
    },
    getOrderStatusType(status) {
      const opt = this.orderStatusOptions.find(o => o.id === String(status))
      return opt ? (opt.type || 'info') : 'info'
    },
    getOrderStatusName(status) {
      const opt = this.orderStatusOptions.find(o => o.id === String(status))
      return opt ? opt.name : status
    },
    getPayTypeName(type) {
      const opt = this.payTypeOptions.find(o => o.id === String(type))
      return opt ? opt.name : (type || '--')
    },
    transferScene(row) {
      if(row.payType == '4'){
        return "系统支付"
      }
      if(row.payType == '3'){
        return "余额支付"
      }
      let scene = row.scene;
      if(!scene){
        return ""
      }
      let obj = {
        "h5": "H5",
        "web": "网页",
        "website": "国际站",
        "wechat": "公众号",
        "wcMini": "智汇桔小程序",
        "intMini": "国际环球流量小程序",
        "xrsWx": "xrs微信H5",
        "xrsAli": "xrs支付宝H5",
      };
      return obj[scene];
    },
    //是否展示退款按钮
    showRefund(row) {
      if(!row.refund){
        return false
      }
      if(row.orderStatus != '3'){
        return false
      }
      //系统支付
      if(row.payType == '4'){
        return false
      }
      //是否一级代理商
      if(this.firstAgent){
        return true
      }
      //管理员需要配置权限
      if(this.checkPermi(['card:multiNet:order:refund'])){
        return true
      }
      return false
    }, 
    // 打开退款弹窗，加载退款详情（可退金额等）
    handleRefund(row) {
      this.refundOrder = row
      this.refundDetailData = {}
      this.refundMaxAmount = Number(row.accountMoney) || 0
      this.refundForm = {
        mode: '1',
        refundAmount: undefined,
        remark: ''
      }
      this.refundDialogVisible = true
      this.refundDetailLoading = true
      refundDetail({ orderNum: row.orderNum }).then(res => {
        this.refundDetailLoading = false
        if (res.data.code == 200 && res.data.data) {
          this.refundDetailData = res.data.data
          // 优先以退款详情接口返回的可退金额为准
          if (res.data.data.canRefundMoney != null) {
            this.refundMaxAmount = Number(res.data.data.canRefundMoney) || 0
          }
          // 默认退全部可退金额
          this.refundForm.refundAmount = this.refundMaxAmount
        }
      }).catch(() => {
        this.refundDetailLoading = false
        this.refundForm.refundAmount = this.refundMaxAmount
      })
    },
    // 确定退款
    confirmRefund() {
      const { mode, refundAmount, remark } = this.refundForm
      if (!refundAmount || refundAmount <= 0) {
        this.$message.error('请输入退款金额')
        return
      }
      if (refundAmount > this.refundMaxAmount) {
        this.$message.error('退款金额不能超过最多可退金额')
        return
      }
      this.$confirm(`确认对订单 ${this.refundOrder.orderNum} 退款 ${refundAmount} 元?`, '退款确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.refundSubmitting = true
        // 已开通自动续费的订单，退款会解约，需二次提示
        checkOrderAutoRenewal({ orderNum: this.refundOrder.orderNum }).then(res => {
          if (res.data.data) {
            this.$confirm('该订单已开通自动续费功能，退款将导致解约，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.doRefund()
            }).catch(() => {
              this.refundSubmitting = false
            })
          } else {
            this.doRefund()
          }
        }).catch(() => {
          this.refundSubmitting = false
        })
      }).catch(() => {})
    },
    doRefund() {
      const { mode, refundAmount, remark } = this.refundForm
      refundRefundOrder({
        orderNum: this.refundOrder.orderNum,
        mode: mode,
        refundAmount: refundAmount,
        remark: remark
      }).then(res => {
        this.refundSubmitting = false
        this.$message.success('退款成功')
        this.refundDialogVisible = false
        this.getOrderList()
      }).catch(() => {
        this.refundSubmitting = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.multi-net-info {
  padding: 16px;
  background: #f0f2f5;
  min-height: 100%;

  .info-section {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    padding: 20px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 20px;
      padding-left: 10px;
      border-left: 3px solid #409eff;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 32px;

    .info-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1.8;

      .info-label {
        color: #909399;
        flex: 0 0 auto;
        width: 140px;
        white-space: nowrap;

        .sync-tip-icon {
          margin-left: 4px;
          color: #409eff;
          cursor: pointer;
        }
      }

      .info-value {
        color: #303133;
        font-weight: 600;
        flex: 1;

        &.status-active {
          color: #67c23a;
        }

        // 多网卡状态颜色，与 multiNet/index.vue 列表 el-tag 配色一致
        // el-tag type="success" / "danger" / "info"
        &.status-success {
          color: #67c23a;
        }
        &.status-danger {
          color: #f56c6c;
        }
        &.status-info {
          color: #909399;
        }
      }
    }
  }

  .member-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 20px;

    .member-card {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;

      .member-card-header {
        background: #f5f7fa;
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        border-bottom: 1px solid #ebeef5;
      }

      .member-card-body {
        padding: 16px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px 16px;

        .member-info {
          display: flex;
          align-items: center;
          font-size: 13px;
          line-height: 1.8;

          .member-label {
            color: #909399;
            flex: 0 0 auto;
            width: 80px;
            white-space: nowrap;
          }

          .member-value {
            color: #303133;
            font-weight: 600;

            // 可点击跳转卡详情的 ICCID
            &.card-link {
              color: #409eff;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            &.status-active {
              color: #67c23a;
            }
            &.status-danger {
              color: #f56c6c;
            }
            &.status-primary {
              color: #409eff;
            }
          }
        }
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
  }

  .filter-bar {
    margin-bottom: 16px;

    .filter-select {
      width: 260px;
    }
  }

  .data-table {
    margin-bottom: 16px;

    .refund-btn {
      padding: 0;
    }

    .no-refund-text {
      color: #c0c4cc;
    }
  }

  // 退款弹窗
  .refund-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #409eff;

    & + .refund-info-grid {
      margin-bottom: 16px;
    }
  }

  .refund-info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 24px;

    .refund-info-item {
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: 1.8;

      .label {
        color: #909399;
        flex: 0 0 auto;
        white-space: nowrap;
      }

      .value {
        color: #303133;
        font-weight: 600;
        word-break: break-all;

        &.refund-money {
          color: #f56c6c;
        }
      }
    }
  }

  .refund-tip {
    margin-left: 8px;
    color: #909399;
    font-size: 12px;
  }

  .flow-stats-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;
    color: #909399;
    font-size: 14px;

    i {
      font-size: 48px;
      margin-bottom: 16px;
      color: #dcdfe6;
    }
  }

  // 诊断中提示
  .diagnosis-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;
    color: #909399;
    font-size: 14px;

    i {
      font-size: 28px;
      margin-bottom: 12px;
      color: #409eff;
    }
  }

  // 未组网诊断失败提示
  .diagnosis-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 0;
    color: #909399;
    font-size: 14px;

    i {
      font-size: 28px;
      margin-bottom: 12px;
      color: #e6a23c;
    }
  }

  .diagnosis-list {
    .diagnosis-item {
      display: flex;
      align-items: flex-start;
      padding: 16px 0;
      border-bottom: 1px solid #ebeef5;

      &:last-child {
        border-bottom: none;
      }

      .diagnosis-icon {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        background: #409EFF;

        i {
          font-size: 20px;
          color: #fff;
        }
      }

      .diagnosis-content {
        flex: 1;

        .diagnosis-title {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .title-text {
            font-size: 15px;
            font-weight: 600;
            color: #303133;
            margin-right: 12px;
          }

          .el-tag {
            display: inline-flex;
            align-items: center;

            i {
              margin-right: 2px;
            }
          }
        }

        .diagnosis-detail {
          .detail-row {
            display: flex;
            align-items: center;
            font-size: 13px;
            line-height: 1.9;

            .detail-label {
              color: #909399;
              flex: 0 0 auto;
              width: 120px;
            }

            .detail-value {
              color: #303133;
              flex: 1;
            }
          }

          // 绑定状态：锁定状态文案与iccid保持间距
          &.diagnosis-detail--lock {
            .detail-value {
              flex: 0 1 auto;
            }
            .detail-lock {
              margin-left: 12px;
              flex: 0 0 auto;

              &.is-locked {
                color: #f56c6c;
              }
              &.is-unlocked {
                color: #67c23a;
              }
            }
          }

          // 实名/区域：备注文案与iccid保持间距
          &.diagnosis-detail--remark {
            .detail-value {
              flex: 0 1 auto;
            }
            .detail-remark {
              margin-left: 12px;
              flex: 0 0 auto;
              color: #67c23a;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .multi-net-info {
    .info-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .multi-net-info {
    .info-grid {
      grid-template-columns: 1fr;
    }

    .member-cards {
      grid-template-columns: 1fr;
    }
  }
}
</style>